export default "__VITE_ASSET__322844dd__"